import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Utilities } from '@app/core/utils/utilities';

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {
  httpClient = inject(HttpClient);
  util = inject(Utilities);

  getInstitutionRefData() {
    return this.httpClient.get(apiEndpointURL.institutionReferenceEndpoint);
  }

  getInstitutionAjaxDetails(filterBy: any, institutionId?: any) {
    const params = new HttpParams().set("filterBy", filterBy);
    let url;
    if (institutionId)
      url = [apiEndpointURL.easyLoadReportFilterData, institutionId, "filterData"].join('/');
    else
      url = [apiEndpointURL.getInstitutionEndpoint, "filterData"].join('/');
    return this.httpClient.get(url, { params });
  }

  getInstitutionJson() {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get<any>(apiEndpointURL.institutionFieldJson, { params });
  }

  createInstitution(detailsToSave: any) {
    return this.httpClient.post(apiEndpointURL.getInstitutionEndpoint, detailsToSave);
  }

  getInstitutionDetails(institutionId: any, from?: string) {
    let params = new HttpParams();
    if (from === 'resolver') params = params.set('resolver', 'true');
    const viewInstitutionDetailsUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId].join('/');
    return this.httpClient.get(viewInstitutionDetailsUrl, { params });
  }

  updateInstitutionDetails(institutionId: any, detailsToSave: any) {
    const updateInstDetailsUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId].join('/');
    return this.httpClient.put(updateInstDetailsUrl, detailsToSave);
  }

  getRelatedInstitutionJSONData() {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get(apiEndpointURL.relatedInstitutionFieldJson, { params });
  }

  getRelatedInstitutionRefData() {
    return this.httpClient.get(apiEndpointURL.relatedInstitutionRefEndpoint);
  }

  saveRelatedInstitution(institutionId: any, detailsToSave: any) {
    return this.httpClient.post([apiEndpointURL.getInstitutionEndpoint, institutionId, 'relatedinstitutions'].join('/'), detailsToSave);
  }

  getRelatedInstitutionDetails(institutionId: any, institutionRelationshipId: any) {
    const viewUrl = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'relatedinstitutions', institutionRelationshipId].join('/')
    return this.httpClient.get(viewUrl);
  }

  getRelatedInstitutionList(institutionId: number, pageNo: number, sortBy?: any, sortOrder?: any) {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'relatedinstitutions'].join('/');
    let params = new HttpParams().set('pageNumber', pageNo).set('pageSize', 100);
    if (sortBy)
      params = params.set('sortBy', sortBy);
    if (sortOrder)
      params = params.set('sortOrder', sortOrder);

    return this.httpClient.get<any>(url, { params });
  }

  linkOrUnlinkRelatedInstitution(institutionId: any, institutionRelationshipId: any, opt: 'relink' | 'unlink') {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, 'relatedinstitutions', institutionRelationshipId, opt].join('/');
    const bodyContent = { updatedBy: Number(this.util.getStoredUserDetails().userId) };
    return this.httpClient.patch(url, bodyContent);
  }

  archiveOrUnarchiveInstitution(institutionId: any, status: string) {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, status].join('/');
    const bodyContent = { updatedBy: Number(this.util.getStoredUserDetails().userId) };
    return this.httpClient.patch(url, bodyContent);
  }
}